import { TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var Caract_fusionComponent = /** @class */ (function () {
    function Caract_fusionComponent(dialog) {
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.numeroForms = 0;
        this.totalsup = 0;
        this.form = new FormGroup({
            caract_fusion: new FormControl(''),
            sup_ant_loteo: new FormControl(''),
            num_anteproy_act: new FormControl(''),
            sup_anteproy_act: new FormControl(''),
            hoja_anexa_loteo: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("caract_fusion"))) {
            localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("caract_fusion"));
            this.form.controls['sup_ant_loteo'].setValue(this.rows[0] ? this.rows[0].sup_ant_loteo : '');
            this.form.controls['num_anteproy_act'].setValue(this.rows[0] ? this.rows[0].num_anteproy_act : '');
            this.form.controls['sup_anteproy_act'].setValue(this.rows[0] ? this.rows[0].sup_anteproy_act : '');
            this.form.controls['hoja_anexa_loteo'].setValue(this.rows[0] ? this.rows[0].hoja_anexa_loteo : '');
        }
        this.caract_fusion = { sup_ant_loteo: '', num_anteproy_act: '', sup_anteproy_act: '', hoja_anexa_loteo: '' };
        this.temp_carct_loteo = { sup_ant_loteo: '', num_anteproy_act: '', sup_anteproy_act: '', hoja_anexa_loteo: '' };
    }
    Caract_fusionComponent.prototype.add_caract_fusion = function () {
        this.actualRow = localStorage.getItem("caract_fusion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            caract_fusion: this.form.value.caract_fusion,
            sup_ant_loteo: this.form.value.sup_ant_loteo,
            num_anteproy_act: this.form.value.num_anteproy_act,
            sup_anteproy_act: this.form.value.sup_anteproy_act,
            hoja_anexa_loteo: this.form.value.hoja_anexa_loteo
        });
        localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
        this.actualRow2 = localStorage.getItem("caract_fusion");
        console.log(this.actualRow2);
        //this.form.reset();
    };
    Caract_fusionComponent.prototype.get_caract_fusion = function (id) {
        console.log(id);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_carct_loteo.id = id;
                this.temp_carct_loteo.caract_fusion = this.rows[x].caract_fusion;
                this.temp_carct_loteo.sup_ant_loteo = this.rows[x].sup_ant_loteo;
                this.temp_carct_loteo.num_anteproy_act = this.rows[x].num_anteproy_act;
                this.temp_carct_loteo.sup_anteproy_act = this.rows[x].sup_anteproy_act;
                this.temp_carct_loteo.hoja_anexa_loteo = this.rows[x].hoja_anexa_loteo;
                this.dialog.open(this.openModal);
            }
        }
    };
    Caract_fusionComponent.prototype.cleanData = function () {
        this.temp_carct_loteo = { sup_ant_loteo: "", num_anteproy_act: "", sup_anteproy_act: "", hoja_anexa_loteo: "" };
    };
    Caract_fusionComponent.prototype.savecaract_fusion = function () {
        var id = this.temp_carct_loteo.id;
        console.log(this.temp_carct_loteo);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
                $("#clasif_modal").modal("hide");
                this.actualRow = localStorage.getItem("caract_fusion");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    sup_ant_loteo: this.temp_carct_loteo.sup_ant_loteo,
                    num_anteproy_act: this.temp_carct_loteo.num_anteproy_act,
                    sup_anteproy_act: this.temp_carct_loteo.sup_anteproy_act,
                    hoja_anexa_loteo: this.temp_carct_loteo.hoja_anexa_loteo
                });
                localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
                this.temp_carct_loteo = { sup_ant_loteo: "", num_anteproy_act: "", sup_anteproy_act: "", hoja_anexa_loteo: "" };
                this.dialog.closeAll();
            }
        }
    };
    Caract_fusionComponent.prototype.delete_caract_fusion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
            }
        }
    };
    return Caract_fusionComponent;
}());
export { Caract_fusionComponent };
